import 'react';
import '@keystar/ui/picker';
import './index-9799c761.js';
import 'react/jsx-runtime';
import '@keystar/ui/button';
import '@keystar/ui/dialog';
import '@keystar/ui/field';
import '@keystar/ui/layout';
import '@keystar/ui/menu';
import '@keystar/ui/slots';
import '@keystar/ui/typography';
import '@react-aria/i18n';
import '@react-aria/label';
import './index-269488d0.js';
import 'emery';
import '@keystar/ui/drag-and-drop';
import '@keystar/ui/icon';
import '@keystar/ui/icon/icons/trash2Icon';
import '@keystar/ui/list-view';
import '@keystar/ui/tooltip';
import 'slate';
import 'slate-react';
import '@keystar/ui/split-view';
import '@keystar/ui/style';
import '@keystar/ui/icon/icons/panelLeftOpenIcon';
import '@keystar/ui/icon/icons/panelLeftCloseIcon';
import '@keystar/ui/icon/icons/panelRightOpenIcon';
import '@keystar/ui/icon/icons/panelRightCloseIcon';
import '@keystar/ui/checkbox';
import '@keystar/ui/number-field';
import '@keystar/ui/text-field';
import '@keystar/ui/icon/icons/imageIcon';
import '@keystar/ui/link';
import '@keystar/ui/progress';
import '@braintree/sanitize-url';
import '@react-stately/collections';
import '@keystar/ui/action-bar';
import '@keystar/ui/combobox';
import 'minimatch';
import '@keystar/ui/icon/icons/refreshCwIcon';
import '@sindresorhus/slugify';

// this is written like this rather than ArrayField<ComponentSchema> to avoid TypeScript erroring about circularity
function component(options) {
  return options;
}

export { component as c };
